<template lang="pug">
  v-checkbox(
    :value="value"
    :checked="value"
    @input="test"
    :key="ID"
    @click.native="update(value)"
  )
</template>

<script>
export default {
  inject: ['svc'],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    ID: {
      type: Number,
      required: true
    }
  },

  data:() => ({
    loading: true
  }),
  
  methods: {
    async update(val) {
      try {
        console.log('enter')
        this.loading = true
        await this.svc.updateHasComeToCourse(this.ID, !this.value)
        this.$notify({type: 'success', text: 'Mark as come'})

      } catch (error) {
        console.log('error')
      }
      finally {
        this.loading = false
      }
      
    },
    test() {

    }
  }
}
</script>